import { NavLink } from 'react-router-dom'
import { Home, BarChart2, Sparkles, Settings, type LucideIcon } from 'lucide-react'

interface Tab {
  path: string
  label: string
  icon: LucideIcon
  ariaLabel: string
}

const TABS: Tab[] = [
  {
    path: '/',
    label: 'Dashboard',
    icon: Home,
    ariaLabel: 'Go to Dashboard',
  },
  {
    path: '/peaks',
    label: 'Peaks',
    icon: BarChart2,
    ariaLabel: 'Go to Peaks',
  },
  {
    path: '/insights',
    label: 'Insights',
    icon: Sparkles,
    ariaLabel: 'Go to Insights',
  },
  {
    path: '/settings',
    label: 'Settings',
    icon: Settings,
    ariaLabel: 'Go to Settings',
  },
]

export default function TabBar() {
  return (
    <nav
      role="tablist"
      aria-label="Main navigation"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        height: 'calc(49px + env(safe-area-inset-bottom))',
        paddingBottom: 'env(safe-area-inset-bottom)',
        backgroundColor: 'var(--tab-bar-bg)',
        borderTop: '0.5px solid var(--tab-bar-border)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      {TABS.map(({ path, label, icon: Icon, ariaLabel }) => (
        <NavLink
          key={path}
          to={path}
          end={path === '/'}
          role="tab"
          aria-label={ariaLabel}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '3px',
            height: '49px',
            textDecoration: 'none',
            color: isActive ? 'var(--accent-primary)' : 'var(--text-tertiary)',
            transition: 'color 150ms ease',
            WebkitTapHighlightColor: 'transparent',
          })}
        >
          {({ isActive }) => (
            <>
              <Icon
                size={24}
                strokeWidth={isActive ? 2.5 : 1.75}
                aria-hidden="true"
              />
              <span
                style={{
                  fontSize: '10px',
                  fontWeight: isActive ? 600 : 400,
                  lineHeight: 1,
                  letterSpacing: '0.01em',
                }}
              >
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
